import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import FormGroup from '../../Components/Form_Group';
import BasicModal from '../../Components/Modal_Basic';
import File_Modal from '../../Components/File_Modal';
import FileForm from '../../Components/FileForm';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
// import { useDropzone } from "react-dropzone";
function Bm10040(props) {
    const gridRef = React.useRef();
    const [modalToggle1, setModalToggle1] = React.useState(false);
    const [fileInputs, setFileInputs] = React.useState({
        file: '',
        fileName: '',
    });
    // 그리드 컬럼
    const columnDefs = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장
        },
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '', //거래처코드
        },
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래처명
        },
        {
            field: 'lClassCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Lcategory' && f.lanType === 'COL')[0].lanName
                    : '', //대분류
        },
        {
            field: 'mClassCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Mcategory' && f.lanType === 'COL')[0].lanName
                    : '', //중분류
        },
        {
            field: 'custShortName',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustShortNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래처약정명
        },
        {
            field: 'businessLicenNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BusinessLineNo' && f.lanType === 'COL')[0].lanName
                    : '', //사업자번호
        },
        {
            field: 'custTel',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PhoneNumber' && f.lanType === 'COL')[0].lanName
                    : '', //전화번호
        },
        {
            field: 'custCompCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCompCd' && f.lanType === 'COL')[0].lanName
                    : '', //고객사코드
        },
        {
            field: 'cdGubunNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CdGubun' && f.lanType === 'COL')[0].lanName
                    : '', //결제유형
        },
        {
            field: 'custTypeNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustTypeNm' && f.lanType === 'COL')[0].lanName
                    : '', //유형
        },
        {
            field: 'corpLicenNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CorpLicenNo' && f.lanType === 'COL')[0].lanName
                    : '', //법인번호
        },
        {
            field: 'ceoNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CeoNm' && f.lanType === 'COL')[0].lanName
                    : '', //대표이사
        },
        {
            field: 'businesType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BusinessType' && f.lanType === 'COL')[0].lanName
                    : '', //종목
        },
        {
            field: 'businesCondi',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BusinessCondi' && f.lanType === 'COL')[0].lanName
                    : '', //업태
        },
        {
            field: 'personCharg',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PersonCharg' && f.lanType === 'COL')[0].lanName
                    : '', //담당자
        },
        {
            field: 'eMail',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Email' && f.lanType === 'COL')[0].lanName
                    : '', //이메일
        },
        {
            field: 'custFilename',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_FileNm' && f.lanType === 'COL')[0].lanName
                    : '', //파일명
        },
        {
            field: 'faxNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_FaxNo' && f.lanType === 'COL')[0].lanName
                    : '', //팩스번호
        },
        {
            field: 'address1',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Address1' && f.lanType === 'COL')[0].lanName
                    : '', //주소1
        },
        {
            field: 'address2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Address2' && f.lanType === 'COL')[0].lanName
                    : '', //주소2
        },
        {
            field: 'cityNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CityNm' && f.lanType === 'COL')[0].lanName
                    : '', //도시명
        },
        {
            field: 'nationCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_NationCd' && f.lanType === 'COL')[0].lanName
                    : '', //국가
        },
        {
            field: 'businesCloseDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BusinessCloseDt' && f.lanType === 'COL')[0].lanName
                    : '', //폐업일자
        },
        {
            field: 'currencyNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CurrencyNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래통화
        },
        {
            field: 'useYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UseYn' && f.lanType === 'COL')[0].lanName
                    : '', //사용유무
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
            minWidth: 150,
            editable: false,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            editable: false,
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
            minWidth: 150,
            editable: false,
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            editable: false,
        },
    ];
    // 그리드 ROW CLICK EVENT
    const onCellClicked = (e) => {
        const selected = e.data;
        props.setInputs({
            ...props.inputs,
            address1: selected.address1,
            address2: selected.address2,
            businesCloseDt: selected.businesCloseDt,
            businesCondi: selected.businesCondi,
            businesType: selected.businesType,
            businessLicenNo: selected.businessLicenNo,
            cdGubun: selected.cdGubun,
            custFilePathName: selected.custFilename ? selected.custFilename : '',
            custFilePath: selected.custFilePath ? selected.custFilePath : '',
            itemFilename: selected.custFilename ? selected.custFilename : '',
            custType: selected.custType,
            ceoNm: selected.ceoNm,
            cityNm: selected.cityNm,
            custTel: selected.custTel,
            corpLicenNo: selected.corpLicenNo,
            createDate: selected.createDate,
            createId: selected.createId,
            currencyCd: selected.currencyCd,
            custCd: selected.custCd,
            custCompCd: selected.custCompCd,
            custNm: selected.custNm,
            custShortName: selected.custShortName,
            eMail: selected.eMail,
            lClassCd: selected.lClassCd,
            mClassCd: selected.mClassCd,
            nationCd: selected.nationCd,
            personCharg: selected.personCharg,
            plantCd: selected.plantCd,
            updateDate: selected.updateDate,
            updateId: selected.updateId,
            useYn: selected.useYn,
            faxNo: selected.faxNo,
            custType: selected.custType,
        });
    };

    const AuthGroupSettingClicked1 = (_data) => {
        // props.GetSalesOrderItemdtls(saveSoNo);
        setModalToggle1(true);
        setFileInputs({
            ...fileInputs,
            // file: "",
        });
        props.setAuthGroupGridRowData([]);
    };
    React.useEffect(() => {
        document.title = '거래처관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>거래처관리</strong>" +
            '</h1>';
        if (props.checkCustCdToggle === true) {
            props.setInputs({
                ...props.inputs,
                custCd: props.checkInputs.value1,
            });
        }
        props.setCheckInputs({
            ...props.checkInputs,
            value1: '',
        });
        props.setCheckCustCdToggle(false);
    }, [props.checkCustCdToggle]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '60%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    {/* 왼쪽 그리드 버튼 */}
                    <AuthGroupButton
                        pageName="BM10040"
                        target="G01"
                        refreshNone="none"
                        addFunc={() =>
                            // gridRef.current.api.setRowData([{}, ...props.rowData])
                            props.setModalToggle(true)
                        }
                        saveFunc={() => props.SaveConfirm()}
                        deleteFunc={() => props.DeleteConfirm()}
                    />
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    {/* 왼쪽 그리드 */}
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 150,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        rowData={props.rowData}
                        rowSelection="multiple"
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        onSelectionChanged={() => {
                            GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData);
                        }}
                        getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        onCellClicked={onCellClicked}
                    />
                </div>
            </div>
            <div style={{ width: '40%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    {/* 폼 버튼 */}
                    <AuthGroupButton
                        pageName="BM10040"
                        target="F01"
                        refreshFunc={() => {
                            props.setInputs({
                                ...props.inputs,
                                address1: '',
                                address2: '',
                                businesCloseDt: '',
                                businesCondi: '',
                                businesType: '',
                                businessLicenNo: '',
                                cdGubun: '',
                                custType: '',
                                ceoNm: '',
                                cityNm: '',
                                corpLicenNo: '',
                                createDate: '',
                                createId: '',
                                currencyCd: '',
                                custCd: '',
                                custType: '',
                                custCompCd: '',
                                custNm: '',
                                custShortName: '',
                                eMail: '',
                                lClassCd: '',
                                mClassCd: '',
                                nationCd: '',
                                personCharg: '',
                                plantCd: '',
                                updateDate: '',
                                updateId: '',
                                useYn: 'Y',
                                faxNo: '',
                            });
                            props.setSelectedRowData([]);
                        }}
                        addFunc={() => {
                            props.setModalToggle(true);
                        }}
                        saveFunc={() => props.SaveConfirm()}
                        deleteFunc={() => props.DeleteConfirm()}
                    />
                </Card>
                <Card style={{ height: '770px', marginTop: '0px' }}>
                    <FormGroup
                        datas={[
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CustCd' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //거래처코드
                                required: true,
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.custCd ? props.inputs.custCd : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        custCd: value,
                                    });
                                },
                                readOnly: true,
                            },
                            {
                                type: 'combo',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_PlantCd' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //사업장
                                combos: props.inputs.comboPlantList,
                                value: props.inputs.plantCd,
                                onChange: (e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        plantCd: e,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CustNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //거래처명
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.custNm ? props.inputs.custNm : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        custNm: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_Lcategory' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //대분류
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.lClassCd ? props.inputs.lClassCd : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        lClassCd: value,
                                    });
                                },
                            },
                            {
                                type: 'combo',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CustTypeNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //유형
                                combos: props.inputs.custTypeList,
                                value: props.inputs.custType,
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        custType: e,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_Mcategory' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //중분류
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.mClassCd ? props.inputs.mClassCd : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        mClassCd: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CustShortNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //거래처약칭명
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.custShortName ? props.inputs.custShortName : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        custShortName: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_BusinessLineNo' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //사업자번호
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.businessLicenNo ? props.inputs.businessLicenNo : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        businessLicenNo: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_PhoneNumber' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //전화번호
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.custTel ? props.inputs.custTel : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        custTel: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CustCompCd' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //고객사코드
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.custCompCd ? props.inputs.custCompCd : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        custCompCd: value,
                                    });
                                },
                            },

                            {
                                type: 'combo',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CdGubun' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //결제유형
                                combos: props.inputs.cdGubunList,
                                value: props.inputs.cdGubun,
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        cdGubun: e,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CorpLicenNo' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //법인번호
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.corpLicenNo ? props.inputs.corpLicenNo : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        corpLicenNo: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CeoNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //대표이사
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.ceoNm ? props.inputs.ceoNm : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        ceoNm: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_BusinessType' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //종목
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.businesType ? props.inputs.businesType : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        businesType: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_BusinessCondi' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //업태
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.businesCondi ? props.inputs.businesCondi : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        businesCondi: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_PersonCharg' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //담당자
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.personCharg ? props.inputs.personCharg : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        personCharg: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_Email' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //이메일
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.eMail ? props.inputs.eMail : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        eMail: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_FaxNo' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //팩스번호
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.faxNo ? props.inputs.faxNo : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    // value = value.replace(
                                    //   /^(\d{2,3})(\d{3,4})(\d{4})$/,
                                    //   `$1-$2-$3`
                                    // );
                                    props.setInputs({
                                        ...props.inputs,
                                        faxNo: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_Address1' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //주소1
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.address1 ? props.inputs.address1 : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        address1: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_Address2' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //주소2
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.address2 ? props.inputs.address2 : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        address2: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CityNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //도시명
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.cityNm ? props.inputs.cityNm : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        cityNm: value,
                                    });
                                },
                            },
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_NationCd' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //국가
                                inputClass: 'input',
                                // nameStyle: true,
                                value: props.inputs.nationCd ? props.inputs.nationCd : '',
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        nationCd: value,
                                    });
                                },
                            },
                            {
                                type: 'date',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_BusinessCloseDt' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //폐업일자
                                inputClass: 'input',
                                value: props.inputs.businesCloseDt,
                                onChange: (e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        businesCloseDt: e,
                                    });
                                },
                                defaultValue: '',
                            },
                            {
                                type: 'combo',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_CurrencyNm' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //거래통화
                                combos: props.inputs.comboCurrecyCd,
                                value: props.inputs.currencyCd,
                                onChange: (e) => {
                                    let { value } = { ...e.target };
                                    props.setInputs({
                                        ...props.inputs,
                                        currencyCd: e,
                                    });
                                },
                            },
                            {
                                type: 'button',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_ImageUpload' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //파일업로드
                                btnName:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_Upload' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '', //업로드 버튼
                                onClick: (e) => {
                                    setModalToggle1(true);
                                },
                            },

                            {
                                type: 'radio',
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                },
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_UseYn' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : '', //사용유무
                                items: [
                                    {
                                        value: 'Y',
                                        name: 'Y',
                                    },
                                    {
                                        value: 'N',
                                        name: 'N',
                                    },
                                ],
                                value: props.inputs.useYn,
                                onChange: (e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        useYn: e.target.value,
                                    });
                                },
                                gubun: '2',
                            },
                        ]}
                    />
                </Card>

                <Section />
            </div>
            <div>
                {/* 이미지첨부 팝업 */}
                {modalToggle1 && (
                    <File_Modal
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Dia_ImageAttachment' && f.lanType === 'DIALOG'
                                  )[0].lanName
                                : '' //이미지첨부
                        }
                        onClose={() => setModalToggle1(false)}
                        buttonName5={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Download' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Upload' && f.lanType === 'BTN')[0]
                                      .lanName
                                : '' //업로드 버튼
                        }
                        deleteButton={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Delete' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        deleteLogic={() => props.FileDeleteConfirm()}
                        downLogic={() => props.FileDownConfirm()}
                        execLogic={() => props.FileConfirm()}
                    >
                        <FileForm
                            datas={[
                                {
                                    type: 'file',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Dia_File' && f.lanType === 'DIALOG'
                                              )[0].lanName
                                            : '', //파일명
                                    value: props.inputs.itemFilePath ? props.inputs.itemFilePath : '',
                                    onChange: (e) => {
                                        var file = e.target.files[0];
                                        props.setFile(file);
                                        props.setFileName(file.name);
                                        if (e.target.files.length === 0) {
                                            return;
                                        } else {
                                            let reader = new FileReader();
                                            reader.readAsDataURL(file);
                                            reader.onload = (f) => {
                                                document.getElementById('imageFile').src = f.target.result;
                                                if (reader) {
                                                    props.setInputs({
                                                        ...props.inputs,
                                                        fileSize: file,
                                                        itemFilePath: reader.result,
                                                        itemFilename: file.name,
                                                    });
                                                }
                                            };
                                        }
                                    },
                                },
                                {
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Dia_FileNm' && f.lanType === 'DIALOG'
                                              )[0].lanName
                                            : '', //파일명
                                    value: props.inputs.custFilePathName,
                                    disabled: true,
                                },
                                {
                                    type: 'image',
                                    id: 'imageFile',
                                    src: props.inputs.custFilePath,
                                },
                            ]}
                        />
                    </File_Modal>
                )}
                <img id="preview" />
            </div>
        </div>
    );
}

export default Bm10040;
